import { sanitizeDecimalInput } from './localeNumber';

export const roundMoney = (value: unknown): number => {
  const numeric = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (!isFinite(numeric) || isNaN(numeric)) return 0;
  return Math.round(numeric * 100) / 100;
};

export const clampMoney = (value: unknown): number => {
  const rounded = roundMoney(value);
  return rounded < 0 ? 0 : rounded;
};

/**
 * Limita un valor de input a máximo 2 decimales
 * @param value - El valor del input
 * @returns El valor limitado a 2 decimales
 */
export const limitToTwoDecimals = (value: string): string => {
  return sanitizeDecimalInput(value, 2);
};

/**
 * Valida si un valor monetario es válido (máximo 2 decimales)
 * @param value - El valor a validar
 * @returns true si es válido, false si no
 */
export const isValidMoneyValue = (value: string): boolean => {
  if (!value) return true;

  const decimalMatch = value.match(/\.(\d+)$/);
  if (decimalMatch && decimalMatch[1].length > 2) {
    return false;
  }

  return true;
};

/**
 * Formatea un valor monetario para mostrar en inputs
 * @param value - El valor numérico
 * @returns El valor formateado como string
 */
export const formatMoneyForInput = (value: number | string): string => {
  if (typeof value === 'number') {
    return value.toFixed(2);
  }
  return value;
};
